<template>
  <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path :fill="color" d="M39.35,54.81h21.33v-1.27c0-1.84-1-3.36-2.99-4.55s-4.55-1.79-7.67-1.79-5.68.6-7.67,1.79c-1.99,1.2-2.99,2.71-2.99,4.55v1.27ZM50.02,43.99c1.48,0,2.73-.51,3.74-1.52,1.01-1.01,1.52-2.26,1.52-3.74s-.51-2.73-1.52-3.74c-1.01-1.01-2.26-1.52-3.74-1.52s-2.73.51-3.74,1.52c-1.01,1.01-1.52,2.26-1.52,3.74s.51,2.73,1.52,3.74c1.01,1.01,2.26,1.52,3.74,1.52ZM23.1,77.11c-.58.58-1.58.17-1.58-.66V28.24c0-1.89.66-3.5,1.98-4.82,1.32-1.32,2.93-1.98,4.82-1.98h43.41c1.89,0,3.5.66,4.82,1.98,1.32,1.32,1.98,2.93,1.98,4.82v32.06c0,1.89-.66,3.5-1.98,4.82-1.32,1.32-2.93-1.98,4.82,1.98h-38.62l-10.01,10.01ZM30.65,61.15h41.08c.21,0,.41-.09.59-.27.18-.18.27-.37.27-.59V28.24c0-.21-.09-.41-.27-.59-.18-.18-.37-.27-.59-.27H28.31c-.21,0-.41.09-.59.27-.18.18-.27.37-.27.59v33.87c0,.83,1,1.24,1.59.65l1.6-1.61ZM27.46,61.15V27.39v33.76Z"/>
  </svg>
</template>

<script>
export default {
  name: 'ChatIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
